export default [
  "granite_transformations_of_cambridge",
  "granite_transformations_of_watford",
  "granite_transformations_of_norwich",
  "granite_transformations_of_holt",
  "granite_transformations_of_newcastle",
  "granite_transformations_of_newark",
  "granite_transformations_of_nottingham",
  "granite_transformations_of_wakefield",
  "granite_transformations_of_york",
  "granite_transformations_north_leeds",
  "granite_transformations_of_ipswich",
  "granite_transformations_of_colchester",
  "granite_transformations_of_belfast",
  "granite_transformations_of_hinckley",
  "granite_transformations_of_tees_valley",
  "granite_transformations_of_tunbridge_wells",
  "granite_transformations_of_ruxley",
  "granite_transformations_of_sevenoaks",
  "granite_transformations_of_derby",
  "granite_transformations_of_bridgemere",
  "granite_transformations_congleton",
  "granite_transformations_of_cheltenham",
  "granite_transformations_of_bristol",
  "granite_transformations_of_banbury",
  "granite_transformations_of_warwick",
  "granite_transformations_of_rugby",
  "granite_transformations_of_gyle",
  "granite_transformations_of_exeter",
  "trend_transformations_of_bolton",
  "trend_transformations_of_kutsford",
  "trend_transformations_of_maidstone",
  "trend_transformations_of_ellesmere_port",
  "trend_transformations_of_burton",
  "trend_transformations_of_speke",
  "trend_transformations_of_perth",
  "trend_transformations_of_plymouth",
  "trend_transformations_of_birmingham_east",
  "trend_transformations_of_milton_keynes",
  "trend_transformations_of_eastbourne",
  "trend_transformations_uk"
];
